/* src/app/pages/contenidos/formcontenidos/formcontenidos.component.scss */
.editor-container_classic-editor .editor-container__editor {
  min-width: 795px;
  max-width: 795px;
}
/*# sourceMappingURL=formcontenidos.component.css.map */
